// @flow
import { createAction } from '@reduxjs/toolkit';

import type { ApiRequest, UploadUserRegistrationKYCParams } from '../types';

export const WS_INIT_REGISTRATION = 'WS_INIT_REGISTRATION';
export const WS_INIT_REGISTRATION_SUCCESS = 'WS_INIT_REGISTRATION_SUCCESS';
export const WS_DISCONNECTED_REGISTRATION = 'WS_DISCONNECTED_REGISTRATION';
export const WS_CLEAR_USER_REGISTRATION_RESPONSES = 'WS_CLEAR_USER_REGISTRATION_RESPONSES';

export const WS_CREATE_USER_REGISTRATION_REQUEST = 'WS_CREATE_USER_REGISTRATION_REQUEST';
export const WS_CREATE_USER_REGISTRATION_ERROR = 'WS_CREATE_USER_REGISTRATION_ERROR';
export const WS_CREATE_USER_REGISTRATION_SUCCESS = 'WS_CREATE_USER_REGISTRATION_SUCCESS';

export const WS_GET_USER_REGISTRATION_REQUEST = 'WS_GET_USER_REGISTRATION_REQUEST';
export const WS_GET_USER_REGISTRATION_ERROR = 'WS_CREATE_USER_REGISTRATION_ERROR';
export const WS_GET_USER_REGISTRATION_SUCCESS = 'WS_GET_USER_REGISTRATION_SUCCESS';

export const WS_SEND_USER_REGISTRATION_SMS_CODE_REQUEST =
  'WS_SEND_USER_REGISTRATION_SMS_CODE_REQUEST';
export const WS_SEND_USER_REGISTRATION_SMS_CODE_ERROR = 'WS_SEND_USER_REGISTRATION_SMS_CODE_ERROR';
export const WS_SEND_USER_REGISTRATION_SMS_CODE_SUCCESS =
  'WS_SEND_USER_REGISTRATION_SMS_CODE_SUCCESS';

export const WS_VALIDATE_USER_REGISTRATION_SMS_CODE_REQUEST =
  'WS_VALIDATE_USER_REGISTRATION_SMS_CODE_REQUEST';
export const WS_VALIDATE_USER_REGISTRATION_SMS_CODE_ERROR =
  'WS_VALIDATE_USER_REGISTRATION_SMS_CODE_ERROR';
export const WS_VALIDATE_USER_REGISTRATION_SMS_CODE_SUCCESS =
  'WS_VALIDATE_USER_REGISTRATION_SMS_CODE_SUCCESS';

export const WS_UPDATE_USER_REGISTRATION_REQUEST = 'WS_UPDATE_USER_REGISTRATION_REQUEST';
export const WS_UPDATE_USER_REGISTRATION_ERROR = 'WS_UPDATE_USER_REGISTRATION_ERROR';
export const WS_UPDATE_USER_REGISTRATION_SUCCESS = 'WS_UPDATE_USER_REGISTRATION_SUCCESS';

export const WS_UPLOAD_USER_REGISTRATION_KYC_REQUEST = 'WS_UPLOAD_USER_REGISTRATION_KYC_REQUEST';
export const WS_UPLOAD_USER_REGISTRATION_KYC_ERROR = 'WS_UPLOAD_USER_REGISTRATION_KYC_ERROR';
export const WS_UPLOAD_USER_REGISTRATION_KYC_SUCCESS = 'WS_UPLOAD_USER_REGISTRATION_KYC_SUCCESS';

export const WS_SCAN_USER_REGISTRATION_KYC_REQUEST = 'WS_SCAN_USER_REGISTRATION_KYC_REQUEST';
export const WS_SCAN_USER_REGISTRATION_KYC_ERROR = 'WS_SCAN_USER_REGISTRATION_KYC_ERROR';
export const WS_SCAN_USER_REGISTRATION_KYC_SUCCESS = 'WS_SCAN_USER_REGISTRATION_KYC_SUCCESS';

export const WS_SUGGEST_NICKNAME_REQUEST = 'WS_SUGGEST_NICKNAME_REQUEST';
export const WS_SUGGEST_NICKNAME_ERROR = 'WS_SUGGEST_NICKNAME_ERROR';
export const WS_SUGGEST_NICKNAME_SUCCESS = 'WS_SUGGEST_NICKNAME_SUCCESS';

export const WS_IS_AVAILABLE_NICKNAME_REQUEST = 'WS_IS_AVAILABLE_NICKNAME_REQUEST';
export const WS_IS_AVAILABLE_NICKNAME_ERROR = 'WS_IS_AVAILABLE_NICKNAME_ERROR';
export const WS_IS_AVAILABLE_NICKNAME_SUCCESS = 'WS_IS_AVAILABLE_NICKNAME_SUCCESS';

export const WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_REQUEST =
  'WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_REQUEST';
export const WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_ERROR =
  'WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_ERROR';
export const WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_SUCCESS =
  'WS_VALIDATE_USER_REGISTRATION_DOMICILIATION_CODE_SUCCESS';

export const WS_SEND_USER_REGISTRATION_VALIDATION_CODE_REQUEST =
  'WS_SEND_USER_REGISTRATION_VALIDATION_CODE_REQUEST';
export const WS_SEND_USER_REGISTRATION_VALIDATION_CODE_ERROR =
  'WS_SEND_USER_REGISTRATION_VALIDATION_CODE_ERROR';
export const WS_SEND_USER_REGISTRATION_VALIDATION_CODE_SUCCESS =
  'WS_SEND_USER_REGISTRATION_VALIDATION_CODE_SUCCESS';

export const WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_REQUEST =
  'WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_REQUEST';
export const WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_ERROR =
  'WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_ERROR';
export const WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_SUCCESS =
  'WS_LIST_INTERNATIONAL_COUNTRY_CALLING_CODES_SUCCESS';
export const WS_SEARCH_PLACES_REQUEST = 'WS_SEARCH_PLACES_REQUEST';
export const WS_SEARCH_PLACES_ERROR = 'WS_SEARCH_PLACES_ERROR';
export const WS_SEARCH_PLACES_SUCCESS = 'WS_SEARCH_PLACES_SUCCESS';
export const WS_CLEAR_SEARCH_PLACES_RESULTS = 'WS_CLEAR_SEARCH_PLACES_RESULTS';
export const WS_GET_PLACE_DETAILS_REQUEST = 'WS_GET_PLACE_DETAILS_REQUEST';
export const WS_GET_PLACE_DETAILS_SUCCESS = 'WS_GET_PLACE_DETAILS_SUCCESS';
export const WS_GET_PLACE_DETAILS_ERROR = 'WS_GET_PLACE_DETAILS_ERROR';
export const WS_CLEAR_GET_PLACE_DETAILS_RESULTS = 'WS_CLEAR_GET_PLACE_DETAILS_RESULTS';

export const uploadUserRegistrationKYCRequest = createAction<
  ApiRequest<UploadUserRegistrationKYCParams>
>(WS_UPLOAD_USER_REGISTRATION_KYC_REQUEST);
